module.exports = __webpack_public_path__ + "img/list_icon6.9cfcf86a.png";